document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.grid--mosaic').forEach((grid) => {
        const images = grid.querySelectorAll('a');
        new SimpleLightbox(images, { fadeSpeed: 200 });
    });
},{once: true});

 /* lazy looad images reveal effect */
const imageReveal = new IntersectionObserver((entries, observer)=>{
    entries.forEach(entry=>{
        if ( entry.isIntersecting ) {
            setTimeout(()=>{
                entry.target.classList.remove('lazy-image--to-reveal');
            }, 500);
            entry.target.classList.add('lazy-image--revealed');
            observer.unobserve(entry.target);
        }
    });
}, {rootMargin: '20px 0px 0px 0px'});

const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
}